import { serializeCodes } from 'app/area/search-filters/serialize/serialize';
import { FilterCommonTypes } from 'app/area/search-filters/types-store';
import { FilterPayloadValues, PredefinedIds } from 'app/area/search-filters/filters/types';
import { SerializePayload } from 'app/area/search-filters/types';
import { filterId, predefinedFiltersId } from './constants';
import { CodeDescriptionSearchModel } from './types-store';

const serializePredefined = (
  formValues: FilterPayloadValues<FilterCommonTypes>
) => {

  const include = formValues && formValues[PredefinedIds.include] || [];

  return {
    [filterId.includeInactiveCodes]: {
      enabled: !include.some(i => i.value === predefinedFiltersId.hideInactiveCodes)
    },
    [filterId.potentiallyUntranslatedOnly]: {
      enabled: include.some(i => i.value === predefinedFiltersId.potentiallyUntranslated)
    }
  };
};

const normalize = (searchModel: CodeDescriptionSearchModel): CodeDescriptionSearchModel => {
  if (!searchModel.query?.text ||
    (!searchModel.query?.searchInDescription && !searchModel.query?.searchInLongDescription)) {
    const { query: _, ...searchModelWithoutQuery } = searchModel;
    return searchModelWithoutQuery;
  }
  return searchModel;
};

export const serialize = (payload: SerializePayload): CodeDescriptionSearchModel => {
  const { formValues, menuValues, filters, filterValidation } = payload;
  const searchModel = {
    ...serializePredefined(formValues),
    ...serializeCodes(formValues, menuValues, filters, filterValidation)
  };

  return normalize(searchModel);
};
